if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      const motionReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (motionReduced) return;

      this.scrollMode = this.dataset.scrollMode || 'marquee';

      const isMobileViewport = window.innerWidth <= 768;

      if (!isMobileViewport && this.scrollMode === 'static') return;

      this.promotion = this.querySelector('.promotion');
      this.#observeInView(this.init.bind(this), { rootMargin: '200px 0px 200px 0px' });
    }
    init() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add('promotion--animated');

        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.appendChild(this.clone);
        }

        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );

        observer.observe(this);
      }
    }

    scrollingPlay() {
      this.classList.remove('scrolling-promotion--paused');
    }

    scrollingPause() {
      this.classList.add('scrolling-promotion--paused');
    }

    // Lightweight IntersectionObserver wrapper so we do not rely on FoxTheme globals
    #observeInView(callback, options) {
      const observer = new IntersectionObserver((entries, obs) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          obs.disconnect();
          callback();
        }
      }, options);

      observer.observe(this);
    }
  }
  customElements.define('scrolling-promotion', ScrollingPromotion);
}
